'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchForIcon = undefined;

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchForIcon = exports.searchForIcon = function searchForIcon(query, count) {
    var requestConfig = {
        url: 'icons',
        params: {
            search: query.toLowerCase(),
            count: count
        },
        timeout: 10000
    };

    return (0, _http2.default)(requestConfig);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/elementIcon/elementIconService.js
// module id = 693
// module chunks = 0